import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { NgModule } from '@angular/core';
import { KeycloakAngularModule } from 'keycloak-angular';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxFileDropModule } from 'ngx-file-drop';
import { LoggerModule } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import {
  CancelBookingDialogComponent,
  CandidateFormComponent,
  ChangeBookingDialogComponent,
  ChangePaymentStatusDialogComponent,
  ConfirmationDialogComponent,
  DashboardBookingCardComponent,
  DashboardExamCardComponent,
  DoPaymentDialogComponent,
  EditEmailDialogComponent,
  ExamBookingHistoryTableComponent,
  ExamCenterFormComponent,
  ExamCenterTableComponent,
  ExamCenterTableFilterComponent,
  ExamEventDetailsDialogComponent,
  ExamEventFormComponent,
  ExamEventStatisticsTableComponent,
  ExamEventTableComponent,
  ExamFormComponent,
  ExamLocationFormComponent,
  ExamLocationTableComponent,
  ExamLocationTableFilterComponent,
  ExamTableComponent,
  ExamTableFilterComponent,
  FooterComponent,
  ForgotPasswordDialogComponent,
  ForgotPasswordSuccessDialogComponent,
  HeaderNavbarComponent,
  I18nButtonComponent,
  InfoPageDialogComponent,
  InviteDialogComponent,
  InviteErrorDialogComponent,
  InviteSuccessDialogComponent,
  LoadingDialogComponent,
  MbrUserRegistrationTimeoutComponent,
  ProfileButtonComponent,
  ProfileCardComponent,
  ProfileEditFormComponent,
  RegisterForExamFormComponent,
  RegisterFormComponent,
  ResetPasswordFormComponent,
  UniversityFormComponent,
  UserFormComponent,
  UserTableComponent,
  UserTableFilterComponent,
} from './components';
import { ExamBookingFormModule } from './components/forms/exam-booking/exam-booking-form.module';
import { AppRoutingModule } from './config/app-routing.module';
import {
  BASE_API_INTERCEPTOR_PROVIDER,
  BASE_API_URL_PROVIDER,
} from './config/base-url.interceptor';
import { KEYCLOAK_PROVIDER } from './config/keycloak';
import { NGX_TRANSLATE_CONFIG } from './config/ngx-translate-config';
import { SharedModule } from './config/shared.module';
import {
  DefaultLayoutComponent,
  MbrRegistrationPageComponent,
  PlainLayoutComponent,
} from './layouts';
import { NotificationModule } from './lib/notification/notification.module';
import { PaginatorComponent } from './lib/table';
import {
  CandidateFormPageComponent,
  ContactPageComponent,
  DashboardPageComponent,
  Error404PageComponent,
  ExamBookingFormPageComponent,
  ExamBookingSummaryPageComponent,
  ExamCenterFormPageComponent,
  ExamCenterPageComponent,
  ExamFormPageComponent,
  ExamLocationFormPageComponent,
  ExamLocationPageComponent,
  ExamPageComponent,
  ImprintPageComponent,
  LandingPageComponent,
  MbrRetrieveNamesPageComponent,
  MyBookingsPageComponent,
  MyRegistrationsPageComponent,
  PrivacyTermsPageComponent,
  ProfileEditPageComponent,
  ProfilePageComponent,
  RegisterPageComponent,
  ResetPasswordFormPageComponent,
  SystemRequirementsPageComponent,
  TermsOfServicePageComponent,
  UniversityFormPageComponent,
  UniversityPageComponent,
  UserFormPageComponent,
  UserPageComponent,
} from './pages';
import { HasRequiredValidatorPipe } from './pipes';
import { ToastComponent } from './services/toast/toast.component';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    AppComponent,
    CancelBookingDialogComponent,
    CandidateFormComponent,
    CandidateFormPageComponent,
    ChangeBookingDialogComponent,
    ChangePaymentStatusDialogComponent,
    ConfirmationDialogComponent,
    ContactPageComponent,
    DashboardBookingCardComponent,
    DashboardExamCardComponent,
    DashboardPageComponent,
    DefaultLayoutComponent,
    DoPaymentDialogComponent,
    EditEmailDialogComponent,
    Error404PageComponent,
    ExamBookingFormPageComponent,
    ExamBookingHistoryTableComponent,
    ExamBookingSummaryPageComponent,
    ExamCenterFormComponent,
    ExamCenterFormPageComponent,
    ExamCenterPageComponent,
    ExamCenterTableComponent,
    ExamCenterTableFilterComponent,
    ExamEventDetailsDialogComponent,
    ExamEventFormComponent,
    ExamEventStatisticsTableComponent,
    ExamEventTableComponent,
    ExamFormComponent,
    ExamFormPageComponent,
    ExamLocationFormComponent,
    ExamLocationFormPageComponent,
    ExamLocationPageComponent,
    ExamLocationTableComponent,
    ExamLocationTableFilterComponent,
    ExamPageComponent,
    ExamTableComponent,
    ExamTableFilterComponent,
    FooterComponent,
    ForgotPasswordDialogComponent,
    ForgotPasswordSuccessDialogComponent,
    HeaderNavbarComponent,
    I18nButtonComponent,
    ImprintPageComponent,
    InfoPageDialogComponent,
    InviteDialogComponent,
    InviteErrorDialogComponent,
    InviteSuccessDialogComponent,
    LandingPageComponent,
    LoadingDialogComponent,
    MbrRegistrationPageComponent,
    MbrRetrieveNamesPageComponent,
    MbrUserRegistrationTimeoutComponent,
    MyBookingsPageComponent,
    MyRegistrationsPageComponent,
    PaginatorComponent,
    PlainLayoutComponent,
    PrivacyTermsPageComponent,
    ProfileButtonComponent,
    ProfileCardComponent,
    ProfileEditFormComponent,
    ProfileEditPageComponent,
    ProfilePageComponent,
    RegisterForExamFormComponent,
    RegisterFormComponent,
    RegisterPageComponent,
    ResetPasswordFormComponent,
    ResetPasswordFormPageComponent,
    SystemRequirementsPageComponent,
    TermsOfServicePageComponent,
    UniversityFormComponent,
    UniversityFormPageComponent,
    UniversityPageComponent,
    UserFormComponent,
    UserFormPageComponent,
    UserPageComponent,
    UserTableComponent,
    UserTableFilterComponent,
    ToastComponent,
  ],
  imports: [
    AccordionModule.forRoot(),
    AppRoutingModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    PaginationModule,
    CollapseModule,
    TooltipModule.forRoot(),
    ExamBookingFormModule,
    KeycloakAngularModule,
    LoggerModule.forRoot({
      level: environment.logLevel,
      disableConsoleLogging: false,
    }),
    NGX_TRANSLATE_CONFIG,
    NgxFileDropModule,
    NotificationModule,
    SharedModule,
    HasRequiredValidatorPipe,
    ModalModule.forRoot(),
  ],
  exports: [AccordionModule],
  providers: [
    KEYCLOAK_PROVIDER,
    BASE_API_URL_PROVIDER,
    BASE_API_INTERCEPTOR_PROVIDER,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
